import { render } from "./AnswerBank.vue?vue&type=template&id=7ebcd7d0&scoped=true"
import script from "./AnswerBank.vue?vue&type=script&lang=js"
export * from "./AnswerBank.vue?vue&type=script&lang=js"

import "./AnswerBank.vue?vue&type=style&index=0&id=7ebcd7d0&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ebcd7d0"]])

export default __exports__